import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const GoalRetirement: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 20 20" strokeWidth={0} {...props}>
            <IconPath
                fill="currentColor"
                fillRule="evenodd"
                d="M2.143 11.857a7.857 7.857 0 0 1 15.714 0H2.143ZM20 13.286H0V14h20v-.714Z"
                clipRule="evenodd"
                {...pathProps}
            />
        </IconSVG>
    );
};
